import React, {Component} from "react";
import FooterComponentOpenData from "../../components/open_data/FooterComponentOpenData";

export class FooterOpenData extends Component{
    render(){
        return(
            <FooterComponentOpenData />
        )
    }
}

export default FooterOpenData;